import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VersionsService {
  private storageKey = 'data-versions:';

  getSavedVersion(dataName: string): number {
    return Number(localStorage.getItem(this.storageKey + dataName));
  }

  saveVersion(dataName: string, version: number): void {
    localStorage.setItem(this.storageKey + dataName, String(version));
  }

}
